/*
 * Copyright (c) 2022-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';

class FixedDialogComponent extends Component {

    componentDidMount() {
        if (this.props.closeTimeout !== undefined) {
            setTimeout(() => {
                if (this.props.close !== undefined) {
                    this.props.close()
                }
            }, this.props.closeTimeout * 100)

        }

    }

    render() {
        return (
            <div aria-live="assertive"
                 className="fixed inset-0 flex items-end  px-4 py-6 pointer-events-none sm:p-6">
                <div className="w-full flex flex-col ">
                    <div
                        className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
                        <div className="flex items-start">
                            <div className="flex-shrink-0">

                            </div>
                            <div className=" w-0 flex-1 p-4">
                                <p className="text-sm font-medium text-gray-900">{this.props.title}</p>

                            </div>
                            <div className="flex border-l border-gray-200">
                                <button onClick={() => {
                                    if (this.props.onButtonClick !== undefined) {
                                        this.props.onButtonClick()
                                    }

                                }}
                                        className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500">
                                    {this.props.buttonText}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

FixedDialogComponent.propTypes = {};

export default FixedDialogComponent;